module.exports = __webpack_public_path__ + "img/o-smile.d18c7127.svg";